<div class="radio-toolbar" style="--height: {{size * 2}}px;">
  <label class="radio-row-label" *ngFor="let option of options; index as idx;" (click)="radioClick(idx)">
    {{option.value}}
  </label>
  <div #circle class="circle" [ngClass]="isLastData ? 'last-data' : 'new-input'" (click)="radioClick(initialIdx)"></div>
</div>